import {
  WSActions,
  WSCard,
  WSInfoBox,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { InfoBoxCCorpTaxLimitations } from "../../../../shared/components/InfoBoxCCorpTaxLimitations";
import { FlowStep } from "../../../../shared/components/FlowSwitch/types";

export const ContractorTaxes: React.FC<FlowStep> = props => {
  return (
    <WSList gap="2XL">
      <WSCard header="Understanding Contractor Taxes">
        <WSList gap="L">
          <WSText.ParagraphSm color="gray500">
            As an independent contractor, you're considered self-employed by the
            IRS. This means you're responsible for:
          </WSText.ParagraphSm>
          <WSInfoBox transparent>
            <ol>
              <li>
                <b>Income Tax</b> (varies by income level)
                <ul>
                  <li>
                    The same tax everyone pays, but without employer withholding
                  </li>
                </ul>
              </li>

              <li>
                <b>Self-Employment Tax</b> (15.3% flat rate)
                <ul>
                  <li>Social Security: 12.4% up to an income threshold</li>
                  <li>Medicare: 2.9% on all income</li>
                </ul>
              </li>

              <li>
                <b>Quarterly Estimated Payments</b>
                <ul>
                  <li>
                    Due 4 times per year (April 15, June 15, Sept 15, Jan 15)
                  </li>
                  <li>Required if you expect to owe $1,000+ in taxes</li>
                  <li>Penalties apply for underpayment or late payment</li>
                </ul>
              </li>
            </ol>
          </WSInfoBox>
          <WSText.ParagraphSm color="gray500">
            Many contractors are surprised by the self-employment tax—it's
            essentially paying both the employee and employer portions of Social
            Security/Medicare.
          </WSText.ParagraphSm>
        </WSList>
      </WSCard>

      <InfoBoxCCorpTaxLimitations />

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Back",
            onClick: props.onBack,
            kind: "Secondary",
            visible: !!props.onBack
          },
          {
            label: "Continue",
            onClick: props.onNext
          }
        ]}
      />
    </WSList>
  );
};
